var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rewards"},[_c('div',{staticClass:"list-container"},[_c('div',[_c('p',{staticClass:"list-title"},[_vm._v("Reward Links")]),_c('p',{staticClass:"list-count"},[_vm._v("Count: "+_vm._s(_vm.ads.length))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }